import { render, staticRenderFns } from "./pageCrumbs.vue?vue&type=template&id=29ad0a63"
import script from "./pageCrumbs.vue?vue&type=script&lang=js"
export * from "./pageCrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports